<template>
  <div>
    <app-cells><h1 class="title">Climbing settings</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'ClimbingSettingsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'climbing-settings-gps', label: 'GPS' },
        { name: 'climbing-settings-equipments', label: 'Equipments' },
        { name: 'climbing-settings-crew', label: 'Crew' },
      ],
    }
  },
}
</script>
